import { render } from "./ticketPresta.vue?vue&type=template&id=03e0856c"
import script from "./ticketPresta.vue?vue&type=script&lang=ts"
export * from "./ticketPresta.vue?vue&type=script&lang=ts"

import "./ticketPresta.vue?vue&type=style&index=0&id=03e0856c&lang=css"
script.render = render

export default script